export interface MinuteParticipantInterface {
    id: number;
    fullName: string;
    avatar?: string;
}

export interface MinuteInterface {
    id: number;
    title: string;
    type: MinuteTypeEnum;
    meetingDate: string;
    participants: MinuteParticipantInterface[];
    agenda: string;
    deliberations: string;
    attachmentUrl?: string;
    attachmentName?: string;
    audioFileUrl?: string;
    audioProcessingStatus?: string;
    audioProcessingError?: string;
    createdBy?: number;
    status: MinuteStatusEnum;
    createdAt: string;
    updatedAt: string;
}

export enum MinuteTypeEnum {
    GENERAL_ASSEMBLY = 'general_assembly',
    COUNCIL = 'council',
    BOARD = 'board',
    MINISTERIAL_MEETING = 'ministerial_meeting',
    OTHER = 'other'
}

export enum MinuteStatusEnum {
    DRAFT = 'draft',
    APPROVED = 'approved',
    ARCHIVED = 'archived',
    IN_TRANSRIPTION = 'in_transcription'
}

export enum AudioProcessingStatusEnum {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

export const MinuteTypeOptions = [
    { value: MinuteTypeEnum.GENERAL_ASSEMBLY, label: 'Assembleia Geral' },
    { value: MinuteTypeEnum.COUNCIL, label: 'Conselho' },
    { value: MinuteTypeEnum.BOARD, label: 'Diretoria' },
    { value: MinuteTypeEnum.MINISTERIAL_MEETING, label: 'Reunião Ministerial' },
    { value: MinuteTypeEnum.OTHER, label: 'Outros' }
];

export const MinuteStatusOptions = [
    { value: MinuteStatusEnum.DRAFT, label: 'Rascunho' },
    { value: MinuteStatusEnum.APPROVED, label: 'Aprovada' },
    { value: MinuteStatusEnum.ARCHIVED, label: 'Arquivada' }
];
